/**
 * Manipulates a url to add and remove query parameters
 * @param {path} string Path of url (without hostname)
 * @param {add} object Properties (key and value) to add to url search parameters
 * @param {remove} array Array of keys to remove from search parameters
 * @returns new path including query parameters
 */
export function updateUrlQuery({ path, add, remove }) {
  const url = new URL(path, 'https://www.example.com');
  if (remove) {
    if (!Array.isArray(remove)) {
      throw new Error(
        `updateUrlQuery 'remove' parameter should be an array of strings`
      );
    }
    for (let item of remove) {
      url.searchParams.delete(item);
    }
  }
  if (add) {
    if (typeof add !== 'object') {
      throw new Error(
        `updateUrlQuery 'add' parameter should be an object with key value strings`
      );
    }
    for (let key of Object.keys(add)) {
      url.searchParams.set(key, add[key]);
    }
  }
  return url.href.replace(url.origin, '').replace(url.protocol, '');
}

/**
 * Splits up a url path into seperate sections and maps them
 * to the names given in the `params` array
 *
 * Ex. getUrlPathParams('/catalog/women/tops/', ['page', 'section', 'category'])
 * returns { page: 'catalog', section: 'women', category: 'tops' }
 *
 * @param {string} url
 * @param {array} params
 * @returns {object}
 */
export function getUrlPathParams(url, params) {
  const parts = url
    .replace(/^\/+|\/+$/g, '') // trim on slashes
    .split('?')[0]
    .split('/');
  return parts.reduce((map, part, index) => {
    map[params[index]] = part === '' ? undefined : part;
    return map;
  }, {});
}

/**
 * Encodes URI part with encodeURIComponent, but also replaces
 * exclamation marks with %21
 * @param {string} str
 * @returns {string}
 */
export function encodeURIPart(str) {
  return encodeURIComponent(str).replace(/!/g, '%21');
}

/**
 *
 * @param {string} str
 * @returns {string}
 */
export function getCatalogPathFromUrl(url) {
  const path = url.split('/catalog/')[1].split('?')[0].split('#')[0];
  let final = path; // path.endsWith('/') ? path.slice(0, -1) : path;
  if (path.endsWith('/')) {
    final = path.slice(0, -1);
  }

  console.log('getCatalogPathFromUrl', final);
  return final;

  // // Split the url on /catalog/ and strip the final /
  // const parts = url.split('/catalog/')[1].split('/');
  // // // Filter out any empty strings from the array to avoid trailing slashes
  // // const filteredParts = parts.filter(part => part !== '');
  // console.log("parts:", parts, parts.join('/'));
  // return parts.join('/');
}
